// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__2XF6A","unreadBadge":"styles_unreadBadge__3p2h2","modalContent":"styles_modalContent__1bm3K","modal":"styles_modal__3NMuV"};